<template>
  <div class="navtab">
    <div class="navtab__box">
      <p class="navtab__box--title">
        Regions
      </p>
      <div v-for="destination in destinations" ref="destination" :key="destination.id">
        <div class="navtab__box--list uppercase" :class="{ 'active' : activeItem == destination }" @click="regions = destination.submenu, activeItem = destination">
          {{ destination.title }}
        </div>
      </div>
    </div>
    <div ref="destinationList" class="navtab__box" :class="{ 'columns' : activeItem && activeItem.title == 'Greece' }">
      <!-- Add loop of regions on active destination -->
      <div v-for="region in regions" :key="region.region">
        <div class="navtab__box--sublist">
          <app-link :id="region.linkId" :type="region.linkType" class="navtab__box--sublist_link">
            {{ region.title }}
          </app-link>
        </div>
      </div>
    </div>
    <div class="navtab__box image">
      <img src="../../../assets/img/src/navbar/destinations-tab/featured-image.jpg" width="432" height="359" alt="Featured Destination Image" class="lazyload">
    </div>
  </div>
</template>

<script>
import HamburgerContent from './HamburgerContent';

export default {
  data() {
    return {
      regions: null,
      activeItem: null,
    };
  },
  computed: {
    destinations() {
      return HamburgerContent.filter((item) => item.title == 'Destinations')[0].submenu;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.columns {
  columns: 2;
  column-gap: 0.5rem;
}

</style>
